import InboxMessagesProvider from './InboxMessagesProvider';
export default InboxMessagesProvider;